export default __webpack_public_path__ + "static/media/fifaIcon.e9d91271.jpg";